export const SCOPE_THREE_PATHS = {
  ROOT: '/inventories',
  CREATE: 'create',
  INVENTORY: ':inventoryId',
  SETUP: 'setup',
  TARGETS: 'targets',
}

export const SCOPE_THREE_ROUTES = {
  ROOT: SCOPE_THREE_PATHS.ROOT,
  CREATE: [SCOPE_THREE_PATHS.ROOT, SCOPE_THREE_PATHS.CREATE].join('/'),
  DETAIL: [SCOPE_THREE_PATHS.ROOT, SCOPE_THREE_PATHS.INVENTORY].join('/'),
  SETUP: [SCOPE_THREE_PATHS.ROOT, SCOPE_THREE_PATHS.INVENTORY, SCOPE_THREE_PATHS.SETUP].join('/'),
  TARGETS: [SCOPE_THREE_PATHS.ROOT, SCOPE_THREE_PATHS.INVENTORY, SCOPE_THREE_PATHS.TARGETS].join(
    '/'
  ),
}
